import React, {useEffect} from 'react';
import {useMetaAPI} from '../../hooks/useMetaAPI';
import {useCart} from '@shopify/hydrogen';

export default function MetaComponent(params) {

  const cart = useCart();
  const { conversion } = useMetaAPI();

  useEffect(() => {
    
    if (cart.lines.length > 0) {
      const contentIds = [];
      cart.lines.forEach((line) => {
        const contentIdValue = {
          contentId: line.id,
          quantity: line.quantity,
          item_price: line.price,
        };
        contentIds.push(contentIdValue);
      });

      const data = {
        contentIds,
        params,
      };
      conversion(data);
    } else {
      const data = {
        contentIds: [],
        ...params,
      };
      console.log('else METAcomponent')
      conversion(data);
    }
  }, [cart]);
}
